import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ContractorsRoutingModule } from './contractors-routing.module';
import { FormsModule } from '@angular/forms';
import { CardTableModule } from 'libs/portal/src/modules/tools/card-table/card-table.module';
import { FiltersModule } from 'libs/portal/src/modules/tools/filters/filters.module';
import { UserModule } from 'libs/portal/src/modules/home/components/user/user.module';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { MatRadioModule } from '@angular/material/radio';
import { ContractorJobsComponent } from './contractor-jobs/contractor-jobs.component';
import { BaseMapComponent } from '@huge-monorepo/shared/components';

@NgModule({
  declarations: [ContractorJobsComponent],
  imports: [CommonModule, FormsModule, CardTableModule, FiltersModule, ContractorsRoutingModule, CardTableModule, UserModule, MaterialModule, MatRadioModule, BaseMapComponent],
})
export class ContractorsModule { }